import { List } from '@mui/material';
import styled from 'styled-components';

interface StyledSideMenuProps {
  $isGsChart: boolean;
}

export const StyledSideMenu = styled(List)<StyledSideMenuProps>`
  position: relative;
  height: inherit;

  .MuiListItemButton-root {
    padding: 10px 11px;

    &.Mui-selected {
      background-color: ${({ $isGsChart }) =>
        $isGsChart
          ? 'linear-gradient(90deg, rgba(15, 215, 153, 0.70) 0%, rgba(33, 98, 79, 0.70) 100%)'
          : 'var(--color-off-white)'};
      border-radius: 4px;

      > .MuiListItemText-root {
        > span {
          color: var(--color-menu-selected) !important ;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }
    }
  }

  .MuiListItemIcon-root {
    min-width: 20px !important;
  }

  .MuiListItemText-root {
    margin-left: 9px;

    ${({ $isGsChart }) =>
      $isGsChart &&
      `
    > span {
      color: var(--color-white) !important;
    }
    `}
  }

  ${({ $isGsChart }) =>
    $isGsChart &&
    `
    .MuiListItemButton-root {
      .MuiSvgIcon-root {
        fill: var(--color-white) !important;
      }
    }
  `}

  .item-icon {
    width: 20px !important;
    height: 20px !important;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .info {
    position: absolute;
    left: 0;
    font-size: 12px;
    bottom: 40px;
    color: #7b7c7c;

    > p {
      line-height: 1.5;
    }
  }
`;
